// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-12-11T11:33:09+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  190785
//    Project:        617
//    Environment:    7626 - master
//    MD5:            1454084009ebf6ee7da45c3ec95efae2
//    Signature:      eyJpdiI6Ik54ODRZRGtSZ0JZZE53eXU5N1lDU0E9PSIsInZhbHVlIjoiYmp0c0RsVk00NnRlNjE2QkRxM1wvK1h0MVNOeW94ZGltd3hhMWtERU9jajV3MjRod0hKQ2JVQlk3bDE2Y1E2SUo2QU5BcFF5eFduY29RWXZUUngyYVF0WWZmQ0crZ05XRnRRR0psb3lLVWpRaFQ0RTR3MWRhXC9KK095M2lTZW1QbTl4QkVvc3RURGFxM2RZUEJBWGZYVk9tVGlEVFEyVktDVk1iM1QzdTVHRHBWTnRKYmY4RFlFbUlhTE1KRWVHbEpVZzNCVFwvMGw0RktlOTd4VEY4bUdEZG1UR09Rc1Vic2JvK00xOUVFc2dwaG10eVlQK3JJSmJLdXdtYlhjV3IzQkcyNDRab2RrbUlOTzZNMm8rTDdoMUgzTnVRc3QyOFFaZzZwT2xZb1VGdTljNHJMbGtCT1k4VWZDQkV0cmVKQ0FhRmRGNmZ2SlhpMTFqemZJaVlRMTZsdE5UcjRmQnJrblpIcURVWUp5eW9GTUI2Z3MxcnBZaGgwcU1BZTJXSGxTYURCSmNwcndDMFI1RjRrXC80ME83VWVWenFtS25NU2E2Q3RKTTlFcndRYTA9IiwibWFjIjoiYTRiZmRjODgxYzZlOGY2MmE0YTQwOTNkYjZlMmVhYzc2OTBmODg4MDQ1N2JmNzVhYWY1NWU2MDljOTdiOTE1YyJ9
class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
